import { t } from '@lingui/macro'
import { Text, View } from '@react-pdf/renderer'
import { myI18n } from 'translation/I18nConnectedProvider'
import {
    defaultFormPdfFontFamily,
    formPDFStyles,
    inuktitutFormPdfFontFamily
} from '../../pdf-components/FormPdf'
import { pdfDefaultFontSize } from '../../pdf-components/PDFCommon'

export const FormUploadFilesFillablePdf = ({
  value,
  elementType,
  typeProps,
  langVersion,
  title,
  helpText,
  tooltip,
  altLabelPlacement,
  condtionsText,
  ...props
}) => {
  const { minFiles, required } = typeProps
  const requiredFilesNumber = minFiles || required ? 1 : 0

  return (
    <>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          fontFamily:
            langVersion === 'iu-cans'
              ? inuktitutFormPdfFontFamily
              : defaultFormPdfFontFamily,
          fontSize: pdfDefaultFontSize,
          marginBottom: 4
        }}
      >
        <View style={formPDFStyles.checkbox} />
        <Text
          style={{
            fontFamily:
              langVersion === 'iu-cans'
                ? inuktitutFormPdfFontFamily
                : defaultFormPdfFontFamily,
            fontSize: pdfDefaultFontSize,
            marginLeft: 8
          }}
        >
          {requiredFilesNumber ? `(${requiredFilesNumber}) ` : ''}
          {tooltip ? `[${tooltip}] ` : ''}
          {title + ' '}
          {required && `(${myI18n._(t`Required`)})`}
          {condtionsText ? <>({condtionsText}) </> : ''}
        </Text>
      </View>
    </>
  )
}
